import 'angular:locale/data:da-DK';
import 'angular:locale/data:en-US';
import './src/polyfills.ts';(globalThis.$localize ??= {}).locale = "___NG_LOCALE_INSERT___";
